const participantType = {
  DIRECT: 'DIRETO',
  INDIRECT: 'INDIRETO'
};

module.exports = participantType;
